module.exports = __webpack_public_path__ + "img/es.60312570.svg";